import { LocationStrategy } from "@angular/common";
import { Component, OnDestroy, OnInit, inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subject, fromEvent, takeUntil } from "rxjs";
import { TimeoutService } from "src/app/services/timeout.service";

interface MessageState {
  message: string;
}

@Component({
  selector: "app-error-page",
  templateUrl: "./error-page.component.html",
  styleUrls: ["./error-page.component.scss"],
})
export class ErrorPageComponent implements OnInit, OnDestroy {
  message: string = "";
  private unsubscriber: Subject<void> = new Subject<void>();

  private _location = inject(LocationStrategy);
  private _translate = inject(TranslateService);
  private _timeout = inject(TimeoutService);

  constructor() {
    this._timeout.idleWatchStop();
  }

  ngOnInit(): void {
    this.message = this._translate.instant("Common.GenericError");
    const state = this._location.getState() as MessageState;
    if (state && typeof state === "object" && "message" in state) {
      this.message = state.message;
    }
    history.pushState(null, "");
    fromEvent(window, "popstate")
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(() => {
        history.pushState(null, "");
      });
  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }
}
